function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useRef, useState } from "react";
import { withNativeProps } from "../../utils/with-native-props";
import cx from "classnames";
import { Popover, Avatar, Loading, Modal, ImageViewer } from "@t8891/mobile";
import { WarningFillIcon } from "@t8891/icon";
var classPrefix = "tc-im-message";
var Custom = function Custom(_ref) {
  var onCustom = _ref.onCustom,
    _ref$recall = _ref.recall,
    recall = _ref$recall === void 0 ? true : _ref$recall,
    _ref$reply = _ref.reply,
    reply = _ref$reply === void 0 ? true : _ref$reply,
    _ref$copy = _ref.copy,
    copy = _ref$copy === void 0 ? true : _ref$copy;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-custom")
  }, copy && /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      return onCustom("copy");
    }
  }, "\u8907\u88FD"), recall && /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      return onCustom("recall");
    }
  }, "\u6536\u56DE"), reply && /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      return onCustom("reply");
    }
  }, "\u56DE\u8986"));
};
var Message = function Message(props) {
  var children = props.children,
    _props$direction = props.direction,
    direction = _props$direction === void 0 ? "left" : _props$direction,
    name = props.name,
    avatarSrc = props.avatarSrc,
    style = props.style,
    recall = props.recall,
    bigAvatarSrc = props.bigAvatarSrc,
    reply = props.reply,
    copy = props.copy,
    onReSend = props.onReSend,
    isFail = props.isFail,
    txtViewer = props.txtViewer,
    isLoading = props.isLoading,
    onCustom = props.onCustom,
    quote = props.quote,
    read = props.read;
  var $ref = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  var baseProps = {
    className: cx(classPrefix, "".concat(classPrefix, "-").concat(direction)),
    style: style
  };
  useEffect(function () {
    if (!txtViewer) return;
    var $dom = $ref.current;
    var timer;
    var isTouchStart = true;
    if ($dom !== null) {
      $dom.addEventListener("touchstart", function () {
        timer = setTimeout(function () {
          isTouchStart = false;
        }, 500); // 设置长按时间阈值，单位为毫秒
      });

      $dom.addEventListener("touchend", function (e) {
        var _a;
        var isQuote = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.getAttribute("data-quote");
        clearTimeout(timer);
        if (isTouchStart && isQuote === "2") {
          Modal.show({
            maskClassName: "".concat(classPrefix, "-modal"),
            content: /*#__PURE__*/React.createElement("div", {
              className: "".concat(classPrefix, "-quote-left")
            }, children),
            closeOnMaskClick: true
          });
        }
        isTouchStart = true;
      });
    }
  }, []);
  return withNativeProps(props, /*#__PURE__*/React.createElement(React.Fragment, null, !!bigAvatarSrc && /*#__PURE__*/React.createElement(ImageViewer, {
    image: avatarSrc,
    visible: visible,
    onClose: function onClose() {
      setVisible(false);
    }
  }), /*#__PURE__*/React.createElement("div", Object.assign({}, baseProps, {
    ref: $ref
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-avatar")
  }, /*#__PURE__*/React.createElement(Avatar, {
    src: avatarSrc,
    onClick: function onClick() {
      setVisible(true);
    }
  })), /*#__PURE__*/React.createElement("div", null, !!quote && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-wrap-quote"),
    style: {
      justifyContent: direction
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-quote"),
    "data-quote": "1",
    onClick: function onClick() {
      Modal.show({
        maskClassName: "".concat(classPrefix, "-modal"),
        content: /*#__PURE__*/React.createElement("div", {
          className: "".concat(classPrefix, "-quote-left")
        }, quote),
        closeOnMaskClick: true
      });
    }
  }, quote)), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-wrap-desc"),
    style: {
      justifyContent: direction
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-desc")
  }, direction !== "right" && !!name && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-name")
  }, name), !!onCustom ? /*#__PURE__*/React.createElement(Popover, {
    content: /*#__PURE__*/React.createElement(Custom, {
      onCustom: onCustom,
      recall: recall,
      reply: reply,
      copy: copy
    }),
    className: "".concat(classPrefix, "-popover"),
    mode: 'dark',
    placement: 'top',
    trigger: 'longTouch',
    autoClose: true,
    style: {
      "--border-radius": "4px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-children"),
    "data-quote": '2'
  }, children)) : /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-children")
  }, children), direction === "right" && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-type")
  }, !isFail && !isLoading && read !== undefined && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-read-status")
  }, read ? "已讀" : "未讀"), isLoading && !isFail && /*#__PURE__*/React.createElement(Loading, {
    isLoading: isLoading,
    icon: /*#__PURE__*/React.createElement("i", {
      className: "".concat(classPrefix, "-loading")
    }),
    size: 'small'
  }), isFail && /*#__PURE__*/React.createElement(WarningFillIcon, {
    onClick: onReSend,
    size: 20,
    fill: '#FF4333'
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-perch")
  }))));
};
Message.defaultProps = {
  direction: "left",
  recall: true,
  reply: true,
  copy: true,
  isFail: false,
  txtViewer: false,
  isLoading: false
};
export default Message;